import React from "react";
import { templateDefaultValue, useTemplateData } from "@constants/template";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import Banner from "./Banner";
import "./shopPage.css";
import BannerImages from "../../Common/BannerImages";
import LanguageTable from "../../Common/LanguageTable";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { templateActions } from "../../templateStore";
import ShopPagePreview from "../../Shop/Website/ShopPagePreview";
import { useSelector } from "react-redux";

export const validUploadedTypes = [
    "image/png",
    "image/jpg",
    "image/jpeg",
    "image/webp",
];

const ShopPage = React.memo(() => {
    const { t } = useTranslation();
    const mainColor = useSelector(
        (state: any) => state.global.infoUser.maincolor
    );
    const { getNestedValue } = useTemplateData();

    const [activeTab, setActiveTab] = React.useState<number>(0);
    const headerImagePathDesktop = React.useMemo(
        () => ["SiteWeb", "ChoixBoutique", "Header", "Image", "Desktop"],
        []
    );
    const headerImagePathMobile = React.useMemo(
        () => ["SiteWeb", "ChoixBoutique", "Header", "Image", "Mobile"],
        []
    );
    const popupImagePathDesktop = React.useMemo(
        () => [
            "SiteWeb",
            "ChoixBoutique",
            "Boutique",
            "Default",
            "Popup",
            "Image",
            "Desktop",
        ],
        []
    );
    const popupImagePathMobile = React.useMemo(
        () => [
            "SiteWeb",
            "ChoixBoutique",
            "Boutique",
            "Default",
            "Popup",
            "Image",
            "Mobile",
        ],
        []
    );
    const popupLogoPathDesktop = React.useMemo(
        () => [
            "SiteWeb",
            "ChoixBoutique",
            "Boutique",
            "Default",
            "Logo",
            "Desktop",
        ],
        []
    );
    const popupLogoPathMobile = React.useMemo(
        () => [
            "SiteWeb",
            "ChoixBoutique",
            "Boutique",
            "Default",
            "Logo",
            "Mobile",
        ],
        []
    );
    const [phoneNumber, setPhoneNumber] = React.useState<any>(
        getNestedValue<any>([
            "SiteWeb",
            "ChoixBoutique",
            "Boutique",
            "Default",
            "Popup",
            "PhoneNumber",
        ])
    );
    const tabs = [
        {
            title: t("Banner"),
            content: (
                <div className="banner-container mt-2">
                    <Banner
                        imagePath={[
                            "SiteWeb",
                            "ChoixBoutique",
                            "Header",
                            "Image",
                        ]}
                    />

                    <section className="text-section">
                        <p className="image-title">{t("Image banner")}</p>
                        <div className="banner-images">
                            <BannerImages
                                dataPath={headerImagePathDesktop}
                                title="Image Desktop"
                                size="1920*480 (png,jpg,jpeg ou webp)"
                            />
                            <BannerImages
                                dataPath={headerImagePathMobile}
                                title="Image Mobile"
                                size="1920*480 (png,jpg,jpeg ou webp)"
                            />
                        </div>
                        <LanguageTable
                            path={["SiteWeb", "ChoixBoutique", "Header"]}
                            fields={[
                                {
                                    key: "Title",
                                    label: "Titre",
                                    placeholder: "Enter the Title",
                                },
                                {
                                    key: "Description",
                                    label: "Description",
                                    placeholder: "Enter the Description",
                                },
                            ]}
                            defaultTexts={
                                templateDefaultValue.SiteWeb.ChoixBoutique
                                    .Header
                            }
                            sectionTitle="Title and Description"
                        />
                    </section>
                </div>
            ),
            customClassName: "",
        },
        {
            title: t("Shop information pop-up"),
            content: (
                <div className="banner-container">
                    <section className="text-section">
                        <p className="image-title">Logo</p>
                        <div className="banner-images">
                            <BannerImages
                                dataPath={popupLogoPathDesktop}
                                title="Desktop"
                                size="300*300 (png,jpg,jpeg ou webp)"
                            />
                            <BannerImages
                                dataPath={popupLogoPathMobile}
                                title="Mobile"
                                size="300*300 (png,jpg,jpeg ou webp)"
                            />
                        </div>
                        <p className="image-title mt-4">
                            {t("Shop Information Image Pop-up")}
                        </p>
                        <div className="banner-images">
                            <BannerImages
                                dataPath={popupImagePathDesktop}
                                title="Desktop"
                                size="706*621 (png,jpg,jpeg ou webp)"
                            />
                            <BannerImages
                                dataPath={popupImagePathMobile}
                                title="Mobile"
                                size="706*621 (png,jpg,jpeg ou webp)"
                            />
                        </div>
                        <p className="image-title mt-4">{t("Connexion")}</p>
                        <div className="image-upload-section mt-2">
                            <span
                                style={{
                                    pointerEvents: "none",
                                    cursor: "default",
                                    fontWeight: "bold",
                                }}
                            >
                                {t("Phone number")}
                            </span>
                            <input
                                type="text"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                style={{ width: "50%" }}
                                maxLength={15}
                                className="form-control epb_inp_timeAS mr-2"
                                onChange={(e: any) => {
                                    const value = e.target.value;
                                    if (/^\d*$/.test(value)) {
                                        setPhoneNumber(e.target.value);
                                        templateActions.updateTemplate(
                                            [
                                                "template",
                                                "SiteWeb",
                                                "ChoixBoutique",
                                                "Boutique",
                                                "Default",
                                                "Popup",
                                                "PhoneNumber",
                                            ],
                                            e.target.value
                                        );
                                    }
                                }}
                                value={phoneNumber}
                            />
                        </div>
                    </section>
                </div>
            ),
            customClassName: "",
        },
    ];

    function toggleNav(tab: number) {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    }
    return (
        <div className="d-flex justify-content-between">
            {activeTab === 1 ? (
                <div style={{ width: "50%" }}>
                    <div style={{ borderBottom: "1px solid #ddd4d4" }}>
                        <Nav
                            tabs
                            style={{
                                backgroundColor: "white",
                                width: "50px",
                                display: "grid",
                                gridTemplateColumns: `repeat(${tabs.length}, 1fr)`,
                                border: "unset",
                            }}
                        >
                            {tabs.map((element, index) => (
                                <NavItem
                                    key={index}
                                    className={classNames(
                                        "pb-1",
                                        "d-flex align-items-center text-nowrap",
                                        {
                                            "disable-nav-item__clz":
                                                activeTab !== index,
                                        },
                                        element.customClassName
                                    )}
                                    style={{
                                        cursor: "pointer",
                                        borderBottom:
                                            activeTab === index
                                                ? `${mainColor} 3px solid`
                                                : "",
                                    }}
                                >
                                    <NavLink
                                        className={classNames(
                                            "text-dark w-100",
                                            {
                                                "active customer-account-menu-nav-link-active__clz":
                                                    activeTab === index,
                                                "customer-account-menu-nav-link-disable__clz":
                                                    activeTab !== index,
                                            }
                                        )}
                                        onClick={() => toggleNav(index)}
                                    >
                                        <span
                                            className="px-2"
                                            style={{
                                                font:
                                                    "normal normal 600 20px/27px Segoe UI",
                                            }}
                                        >
                                            {element.title}
                                        </span>
                                    </NavLink>
                                </NavItem>
                            ))}
                        </Nav>
                    </div>
                    <TabContent activeTab={activeTab} className="h-100">
                        {tabs.map((element, index) => (
                            <TabPane
                                tabId={index}
                                key={index}
                                style={{ height: "90%" }}
                            >
                                {element.content}
                            </TabPane>
                        ))}
                    </TabContent>
                </div>
            ) : (
                <div style={{ width: "100%" }}>
                    <div style={{ borderBottom: "1px solid #ddd4d4" }}>
                        <Nav
                            tabs
                            style={{
                                backgroundColor: "white",
                                width: "50px",
                                display: "grid",
                                gridTemplateColumns: `repeat(${tabs.length}, 1fr)`,
                                border: "unset",
                            }}
                        >
                            {tabs.map((element, index) => (
                                <NavItem
                                    key={index}
                                    className={classNames(
                                        "pb-1",
                                        "d-flex align-items-center text-nowrap",
                                        {
                                            "disable-nav-item__clz":
                                                activeTab !== index,
                                        },
                                        element.customClassName
                                    )}
                                    style={{
                                        cursor: "pointer",
                                        borderBottom:
                                            activeTab === index
                                                ? `${mainColor} 3px solid`
                                                : "",
                                    }}
                                >
                                    <NavLink
                                        className={classNames(
                                            "text-dark w-100",
                                            {
                                                "active customer-account-menu-nav-link-active__clz":
                                                    activeTab === index,
                                                "customer-account-menu-nav-link-disable__clz":
                                                    activeTab !== index,
                                            }
                                        )}
                                        onClick={() => toggleNav(index)}
                                    >
                                        <span
                                            className="px-2"
                                            style={{
                                                font:
                                                    "normal normal 600 20px/27px Segoe UI",
                                            }}
                                        >
                                            {element.title}
                                        </span>
                                    </NavLink>
                                </NavItem>
                            ))}
                        </Nav>
                    </div>
                    <TabContent activeTab={activeTab} className="h-100">
                        {tabs.map((element, index) => (
                            <TabPane
                                tabId={index}
                                key={index}
                                style={{ height: "90%" }}
                            >
                                {element.content}
                            </TabPane>
                        ))}
                    </TabContent>
                </div>
            )}
            {activeTab === 1 && (
                <div style={{ width: "50%" }}>
                    <ShopPagePreview
                        selectedRows={[
                            {
                                Adresse:
                                    "24 B RUE LEONARD DE VINCI, 1256, Tunisie",
                            },
                        ]}
                        imagePath={popupImagePathDesktop}
                        logoPath={popupLogoPathDesktop}
                        PhoneNumber={phoneNumber}
                    />
                </div>
            )}
        </div>
    );
});

export default ShopPage;
